export default __webpack_public_path__ + "static/media/flag.35ce7c3e.svg";